import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Collection, ForEachModel, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import { Can } from '@morningtrain/react-auth'
import * as Displays from 'support/displays'
import * as Accordion from 'support/utilities/accordions'
import MyMessageInner from 'widgets/dashboard/partials/MyMessageInner'

export default function MyMessagesDashboardWidget () {
  return (
    <Can permission='api.messages.messages.latest'>
      <Widget>
        <Translator namespace='dashboard.my_messages'>
          <Collection resourceName='messages.messages' operationName='mine'>
            <SelectedDepartmentFilter />
            <WhenCollectionIsNotEmpty>
              <UI.CardWithHeader header={<Translation name='title' />}>
                <Accordion.Accordion>
                  <ForEachModel>
                    <Accordion.ModelItem
                      title={<Displays.Text name='subject' />}
                      subtitle={(
                        <UI.Text color='gray' size='sm' className='pt-1'>
                          <Displays.DateTime name='show_from' dateFormat='D. MMMM YYYY \- ' />
                        </UI.Text>
                    )}
                    >
                      <MyMessageInner />
                    </Accordion.ModelItem>
                  </ForEachModel>
                </Accordion.Accordion>
              </UI.CardWithHeader>
            </WhenCollectionIsNotEmpty>
          </Collection>
        </Translator>
      </Widget>
    </Can>
  )
}
